/* SLIDE 17 */

import React, { useState } from "react";
import ButtonBot from "shared/components/ButtonBot";
import AppInfoRow from "shared/components/AppInfoRow";
import Popup from "shared/components/Popup";
import SubHeader from "shared/components/SubHeader";
import note2Icon from "assets/icons/note2Icon.svg";
import closeIcon from 'assets/icons/close.svg';

function ParkingPaymentPending() {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <div className="htContainer">
            <SubHeader>
                <div
                    className={`sub-header-text w-full justify-between`}
                >
                    <div className="nl-row">   
                        <img src={note2Icon} alt="Camera" />
                        <span className="ml-5 htBold htColorMain" style={{color: "#585858", fontSize: "16px", fontWeight: "600"}}>결제완료</span>
                    </div>
                    <div>
                        <span className="sub-header-btn">출차</span>
                    </div>

                </div>
            </SubHeader>

            <div className="htContent htHasButtonBot mn-payment-complete">
                <div className="htSection">
                    <h2>차량정보</h2>
                    <AppInfoRow label="차량번호" value="152가 2045" />
                    <AppInfoRow label="입차일시" value="2024-11-20 13:15" />
                    <AppInfoRow label="출차일시" value="2024-11-20 13:15" />
                    <AppInfoRow label="결제요금" value="2,000원" />
                </div>
                <div className="htSeparator" style={{marginBottom: '79px'}}></div>




                <ButtonBot textYes={`홈으로`} handleYes={() => setShowPopup(true)} />
                {showPopup && (
                    <Popup title="결제 확인" handleYes={() => setShowPopup(false)} textYes="아니오 <br/> (미납처리)"  textNo="예 <br/>(결제하기)" setVisible={setShowPopup}>
                        <div className="htPpCamera my-3">
                            <p>결제를 진행하시겠습니까?</p>
                            <p>(결제 미진행 시 미납처리)</p>
                        </div>
                      

                    </Popup>
                )}
            </div>
        </div>
    );
}

export default ParkingPaymentPending;
